import { CollectionId } from '@/scopes/common/components/CollectionCard/types'
import { IconGlyph } from '@sunwebgroup/uds-ui/icon'

export function getCollectionIcon(collectionId: string, brandName: string): IconGlyph {
  if (collectionId === 'primavera') {
    return 'LogoPrimavera'
  }

  if (collectionId === 'totally_snow') {
    return 'LogoTotally'
  }

  if (brandName === 'eliza') {
    return 'LogoElizaWasHere'
  }

  return 'LogoSunweb'
}

export function getCollectionNameId(collectionId: CollectionId) {
  const translationIds = {
    'atlantis': 'collection_name_atlantis',
    'boutique': 'collection_name_boutique',
    'cycling': 'collection_name_cycling',
    'excellent': 'collection_name_excellent',
    'famfun': 'collection_name_famfun',
    'primavera': 'collection_name_primavera',
    'secrets': 'collection_name_secrets',
    'selections': 'collection_name_selections',
    'totally_snow': 'collection_name_totally_snow',
    'villages': 'collection_name_villages',
    'xperience': 'collection_name_xperience',
    'child': 'collection_name_child',
    'pearls': 'collection_name_pearls',
    'culinary': 'collection_name_culinary',
    'romantic': 'collection_name_romantic',
    'newest-discoveries': 'collection_name_newest_discoveries',
  }
  return collectionId in translationIds ? translationIds[collectionId] : 'collection_name_unknown'
}
